export default __webpack_public_path__ + "static/media/Extras_GlossarioDeConfeitaria.769e2a7d.jpg";